module.exports = __webpack_public_path__ + "static/skyway-seed-592a996b58e79843e236ef584c13472a.mp4";